<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
  <v-row >
    <v-col md="12" lg="12" sm="6">
    <v-row class="text-justify">
      <v-col  v-for="cantidad in cantidades" :key="cantidad.negocio" md="4" lg="4" cols="12" class="d-flex flex-column">
        <v-card color="#2f363e" class="rounded-xl flex d-flex flex-column" >
          <v-card-text class="flex">
            <v-row >
              <v-col md="3" sm="3" cols="2" lg="3">
              <v-avatar><img style="width: 100%;" :src="cantidad.icono" ></v-avatar>
              </v-col>
              <v-col md="9" sm="9" cols="10" lg="9">
                <v-row>
                  <v-col  md="12" sm="12" cols="12">
                    <h2  style="color:#fff;" >{{ cantidad.negocio}}</h2>
                  </v-col>
                  <v-col style="color:#fff; font-size:18px;" md="12" cols="12">
                 <v-icon>fas fa-universal-access</v-icon>   {{ cantidad.temporada }}
                  </v-col>
                  <v-col md="12" sm="12" cols="12">
                    <h1 style="color:green;"><v-icon style="color:green;">fas fa-id-badge</v-icon><number
                        ref="number1"
                        :from="0"
                        :to="cantidad.numero"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Power1.easeOut"/> Incritos</h1>
                  </v-col>
                    <v-col md="12" sm="12" cols="12">
                        <h1 style="color:lightblue;"><v-icon style="color:lightblue;">fas fa-stopwatch</v-icon><number
                                ref="number2"
                                :from="0"
                                :to="cantidad.poraceptar"
                                :format="theFormat"
                                :duration="5"
                                :delay="2"
                                easing="Power1.easeOut"/> Por Aceptar</h1>
                    </v-col>
                    <v-col md="12" sm="12" cols="12">
                        <h1 style="color:red;"><v-icon style="color:red;">fas fa-frog</v-icon><number
                                ref="number2"
                                :from="0"
                                :to="cantidad.rechazados"
                                :format="theFormat"
                                :duration="5"
                                :delay="2"
                                easing="Power1.easeOut"/> Rechazados</h1>
                    </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col  v-for="fiesta in fiestas" :key="fiesta.fiesta" md="4" lg="4" cols="12" class="d-flex flex-column">
        <v-card color="#0E8A74" class="rounded-xl flex d-flex flex-column">
          <v-card-text class="flex">
            <v-row >
              <v-col md="3"> <v-row> <v-col md="12">
                <v-avatar><v-icon>fas fa-running</v-icon></v-avatar> <v-avatar><v-icon>fas fa-door-open</v-icon></v-avatar></v-col>
                <v-col md="12">
                  <h1> <number
                      ref="number2"
                      :from="0"
                      :to="fiesta.cantIngresantes"
                      :format="theFormat"
                      :duration="5"
                      :delay="2"
                      easing="Power1.easeOut"/>  </h1>
                </v-col>
              </v-row>
              </v-col>
              <v-col md="9">
                <v-row>
                  <v-col md="12">
                  <h1>  {{fiesta.fiesta}}</h1>
                  </v-col>
                  <v-col md="12">
                  <h3>  {{fiesta.negocio}}</h3>
                  </v-col>
                  <v-col md="12">
                    {{fiesta.fecha}}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col md="6">
                <v-row>
                  <v-col md="12">
                    En Lista Real
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col md="8">
                    <h1> <number
                        ref="number3"
                        :from="0"
                        :to="fiesta.cantListaReal"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Power1.easeOut"/> </h1>
                  </v-col>
                  <v-col  md="2">
                    <v-icon>fas fa-clipboard-list</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-row>
                  <v-col md="12">
                   Con QR
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col md="8">
                    <h1> <number
                        ref="number4"
                        :from="0"
                        :to="fiesta.cantPersonasQR"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Power1.easeOut"/>  </h1>
                  </v-col>
                  <v-col  md="2">
                    <v-icon>fas fa-qrcode</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-row>
                  <v-col md="12">
                    Creados en Lista Total
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col md="8">
                    <h1> <number
                        ref="number5"
                        :from="0"
                        :to="fiesta.cantFiesta"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Power1.easeOut"/> </h1>
                  </v-col>
                  <v-col  md="2">
                    <v-icon>fas fa-user</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-row>
                  <v-col md="12">
                    Reservas
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col md="8">
                    <h1> <number
                        ref="number6"
                        :from="0"
                        :to="fiesta.cantReserva"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Elastic.easeOut"/>  </h1>
                  </v-col>
                  <v-col md="2">
                    <v-icon>fas fa-couch</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col  v-for="cumpls in asistencias"   :key="cumpls.negocios" md="4" lg="3" xl="2" cols="12" class="d-flex flex-column">
        <v-card color="#2f363e" class="rounded-xl flex d-flex flex-column">
          <v-card-title  >
            <h3><v-icon>fas fa-star</v-icon>Top Asistentes  </h3>
          </v-card-title>
          <v-card-subtitle>{{cumpls.negocios}}</v-card-subtitle>
          <v-card-text class="flex">
            <v-row align="center">
              <v-col v-for="nomb in cumpls.topAsistencias" :key="nomb.id" sm="12" md="12" lg="12"  cols="12">
               {{nomb.cuantos}} veces <router-link style="text-decoration: none;"  :to="{ name: 'VerSocio', params: { idpersona: nomb.id }}"> <span style="color:white; font-size: 15px;"> {{nomb.nombre}}</span></router-link>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col  v-for="cumpls in cumpleanos"   :key="cumpls.negocios" md="4" lg="3" xl="2" cols="12" class="d-flex flex-column">
        <v-card color="#2f363e" class="rounded-xl flex d-flex flex-column">
          <v-card-title  >
            <h3><v-icon>fas fa-birthday-cake</v-icon>Cumpleaños</h3>
          </v-card-title>
          <v-card-subtitle>{{cumpls.negocios}} </v-card-subtitle>
          <v-card-text class="flex">
            <v-row align="center">
              <v-col v-for="nomb in cumpls.cumpleClubNombre" :key="nomb.personaId" sm="12" md="12" lg="12"  cols="12">
                <router-link style="text-decoration: none;"  :to="{ name: 'VerSocio', params: { idpersona: nomb.personaId }}"> <span style="color:white; font-size: 15px;">{{nomb.dia}}-{{nomb.mes}} : {{nomb.nombre}}</span></router-link>
               </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>


        </v-row>
    </v-col>
  </v-row>
      <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../general/leftmenu';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      overlay: false,
      cantidades: [],
      fiestas:[],
      mnegocios:[],
      abreviado:'NN',
      token:'',
      cumpleanos: [],
      asistencias: [],
      timer: ''
  }),
  mounted (){
    this.overlay = true
    this.armamenu()

    const auth = firebase.auth()
            if (this.usuario.id === undefined){
              firebase
                  .auth()
                  .onAuthStateChanged(user => {
                    if(user){
                      this.overlay = false
                      this.token  = auth.currentUser.auth.currentUser.accessToken;
                      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                      this.damecantidadxclub();
                      this.timer = setInterval(this.damecantidadxclub, 60000);

                    }else{
                      this.overlay = false
                      this.$router.push({ path: '/' });
                    }
                  })

            }else{
              this.overlay = false
              this.token  = auth.currentUser.auth.currentUser.accessToken;
              this.damecantidadxclub();
              this.timer = setInterval(this.damecantidadxclub, 60000);
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

            }
  },
  watch: {
    '$store.state.usuario': function (){
      const auth = firebase.auth()
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
      }else{
        this.token  = auth.currentUser.auth.currentUser.accessToken;

        this.damecantidadxclub();
        this.timer = setInterval(this.damecantidadxclub, 60000);
      }


    },
  },
  methods : {
    cancelAutoUpdate () {
      clearInterval(this.timer);
    },
    theFormat(number) {
      return number.toFixed(0);
    },
    dameMes(fecha){
      const fsx = new Date(fecha)
      return fsx.getMonth();
    },
    armamenu(){

      this.mnegocios = this.negocios.filter(function (el){
        return el.activo === true;
      })
      this.mnegocios = this.uniqBy(this.mnegocios,it => it.id)

    },
    uniqBy(a, key) {
      return [
        ...new Map(
            a.map(x => [key(x), x])
        ).values()
      ]
    },
 damecantidadxclub(){
        this.overlay = true;
            let urlfiesta = 'clientes/dashboard/' + this.usuario.id;
        axios
        .get(urlfiesta,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.cantidades = response.data.cantidadNegocios;
           this.fiestas = response.data.fiestaClientes;
          this.cumpleanos = response.data.cumpleClubs;
          this.asistencias = response.data.topAsistencias;
          this.cumpleanos = this.cumpleanos.filter(x => x.cumpleClubNombre.length > 0 );
          this.asistencias = this.asistencias.filter(x => x.topAsistencias.length > 0 );

          this.overlay = false;
        })
        .catch((error)  => {
        console.log(error);
          this.overlay = false;
        });
    },

  },
  beforeDestroy() {
    this.cancelAutoUpdate()
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      cliente : "cliente",
      negocios: "negocios"
    })
  }
};
</script>
